import { render, staticRenderFns } from "./UserDetailsModal.vue?vue&type=template&id=77f2da4b"
import script from "./UserDetailsModal.vue?vue&type=script&lang=ts"
export * from "./UserDetailsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports